module.exports = __webpack_public_path__ + "img/gyra_logo@3x.9ec03ef4.png";